"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Compose = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ComposeContext_1 = require("./ComposeContext");
const AttachButton_1 = require("./components/AttachButton/AttachButton");
const AttachedFileErrors_1 = require("./components/AttachedFileList/AttachedFileErrors");
const AttachedFileInfo_1 = require("./components/AttachedFileList/AttachedFileInfo");
const AttachedFileList_1 = require("./components/AttachedFileList/AttachedFileList");
const AttachedFileRows_1 = require("./components/AttachedFileList/AttachedFileRows");
const AttachedFileTitle_1 = require("./components/AttachedFileList/AttachedFileTitle");
const ButtonRow_1 = require("./components/ButtonRow/ButtonRow");
const SendButton_1 = require("./components/SendButton/SendButton");
const Textbox_1 = require("./components/Textbox/Textbox");
const StyledCompose = styled_components_1.default.div `
    display: flex;
    width: 100%;
    flex-flow: column nowrap;
`;
function hasFileUploadProps(props) {
    return "upload" in props;
}
/** Wraps all other Compose elements */
const Compose = (props) => {
    const [isUploadingFile, setIsUploadingFile] = (0, react_1.useState)(false);
    const [uploadingFileErrors, setUploadingFileErrors] = (0, react_1.useState)([]);
    const handleSetIsUploadingFile = (isUploadingFile) => {
        setIsUploadingFile(isUploadingFile);
    };
    const handleSetUploadingFileErrors = (fileErrors) => {
        setUploadingFileErrors(fileErrors);
    };
    let providerValue = {
        canCompose: props.canCompose,
        canSend: props.canSend,
        isSending: props.isSending,
        uploadedFiles: [],
        isUploadingFile,
        setIsUploadingFile: handleSetIsUploadingFile,
        uploadingFileErrors,
        setUploadingFileErrors: handleSetUploadingFileErrors,
        maxFiles: 0,
        uploadFileFunction: undefined,
        maxAllowedFileSize: { size: 0, humanReadable: "0" },
        allowedFileExtensions: [],
    };
    if (hasFileUploadProps(props)) {
        providerValue = Object.assign(Object.assign({}, providerValue), { maxFiles: props.upload.maxFiles, uploadedFiles: props.upload.uploadedFiles, setUploadedFiles: props.upload.setUploadedFiles, uploadFileFunction: props.upload.uploadFileFunction, maxAllowedFileSize: props.upload.maxAllowedFileSize, allowedFileExtensions: props.upload.allowedFileExtensions });
    }
    return (react_1.default.createElement(ComposeContext_1.ComposeProvider, { value: providerValue },
        react_1.default.createElement(StyledCompose, { className: props.className }, props.children)));
};
exports.Compose = Compose;
Compose.Textbox = Textbox_1.Textbox;
Compose.ButtonRow = ButtonRow_1.ButtonRow;
Compose.AttachButton = AttachButton_1.AttachButton;
Compose.AttachedFileList = AttachedFileList_1.AttachedFileList;
Compose.AttachedFileTitle = AttachedFileTitle_1.AttachedFileTitle;
Compose.AttachedFileErrors = AttachedFileErrors_1.AttachedFileErrors;
Compose.AttachedFileInfo = AttachedFileInfo_1.AttachedFileInfo;
Compose.AttachedFileRows = AttachedFileRows_1.AttachedFileRows;
Compose.SendButton = SendButton_1.SendButton;
//# sourceMappingURL=Compose.js.map